// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"ffe9e52b","700":"9ed9a21d"}[chunkId] + ".chunk.css";
};